import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AlertService } from 'app/services/alert.service';
import { LoggerService } from 'app/services/logger.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { InventoryService } from '../services/inventory.service';
import * as InventoryActions from './inventory.actions';

@Injectable()
export class InventoryEffects {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private logger = inject(LoggerService);
    private _inventoryService = inject(InventoryService);
    private _alertService = inject(AlertService);

    messages = {
        getAllError: 'Error getting all inventories',
        connectionError: 'Error connecting to the server',
        unknownError: 'Unknown error',
    };

    // ------------------------------------------------------------------------------------------
    // @ Effects
    // ------------------------------------------------------------------------------------------

    // Get Inventory
    getInventory$ = createEffect(() =>
        this._actions$.pipe(
            ofType(InventoryActions.loadInventory),
            switchMap(() => {
                return this._inventoryService.getAll().pipe(
                    // Debug
                    // tap((res) => console.log(res.data)),
                    map((res) => {
                        return InventoryActions.loadInventorySuccess({
                            data: res.data,
                        });
                    }),
                    catchError((error) =>
                        of(
                            InventoryActions.loadInventoryFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Get Inventory By Location
    getInventoryByLocation$ = createEffect(() =>
        this._actions$.pipe(
            ofType(InventoryActions.loadInventoryByLocation),
            switchMap(() => {
                return this._inventoryService.getAllByLocation().pipe(
                    // tap((res) =>
                    //     this.logger.log('Inventory by location:', res)
                    // ),
                    map((res) => {
                        return InventoryActions.loadInventoryByLocationSuccess({
                            data: res.data,
                        });
                    }),
                    catchError((error) =>
                        of(
                            InventoryActions.loadInventoryByLocationFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Create Inventory
    // createInventory$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(InventoryActions.createInventory),
    //         switchMap((action) => {
    //             return this._inventoryService.create(action.InventoryData).pipe(
    //                 map((res) => {
    //                     return InventoryActions.createInventorySuccess({
    //                         inventory: res.data,
    //                         success: 'Inventory created successfully',
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         InventoryActions.createInventoryFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // Update Inventory
    // updateInventory$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(InventoryActions.updateInventory),
    //         switchMap((action) => {
    //             return this._inventoryService
    //                 .update(action.InventoryData, action.id)
    //                 .pipe(
    //                     map((res) => {
    //                         return InventoryActions.updateInventorySuccess({
    //                             inventory: res.data,
    //                             success: 'Inventory updated successfully',
    //                         });
    //                     }),
    //                     catchError((error) =>
    //                         of(
    //                             InventoryActions.updateInventoryFailure({
    //                                 error:
    //                                     error?.error?.message ||
    //                                     this.messages.unknownError,
    //                             })
    //                         )
    //                     )
    //                 );
    //         })
    //     )
    // );

    // Delete Inventory
    // deleteInventory$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(InventoryActions.deleteInventory),
    //         switchMap((action) => {
    //             return this._inventoryService.delete(action.id).pipe(
    //                 map(() => {
    //                     return InventoryActions.deleteInventorySuccess({
    //                         id: action.id,
    //                         success: 'Inventory deleted successfully',
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         InventoryActions.deleteInventoryFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // ------------------------------------------------------------------------------------------
    // @ Alerts
    // ------------------------------------------------------------------------------------------

    // onInventoryActionSuccess$ = createEffect(
    //     () =>
    //         this._actions$.pipe(
    //             ofType(
    //                 InventoryActions.createInventorySuccess,
    //                 InventoryActions.updateInventorySuccess,
    //                 InventoryActions.deleteInventorySuccess
    //             ),
    //             tap((action) => {
    //                 this._alertService.showAlert(action.success, 'success');
    //             })
    //         ),
    //     { dispatch: false }
    // );

    onInventoryActionFailure$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(
                    InventoryActions.loadInventoryFailure,
                    InventoryActions.loadInventoryByLocationFailure
                    // InventoryActions.loadInventoryFailure,
                    // InventoryActions.createInventoryFailure,
                    // InventoryActions.updateInventoryFailure,
                    // InventoryActions.deleteInventoryFailure
                ),
                tap((action) => {
                    this._alertService.showAlert(action.error, 'error');
                })
            ),
        { dispatch: false }
    );
}
